import { CampaignsListContainer } from '@/features/advertising';

export default function AdsCampaignsPage() {
  return (
    <div className="space-y-6">
      <CampaignsListContainer />
    </div>
  );
}
